import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { AppConfig } from '../config/app.config';
import 'rxjs/add/operator/catch';
import { User } from '../shared/user.model';

@Injectable()
export class Authentication {
    private _userKey: string = "CURRENT_USER";
    private _userRolesKey: string = "USER_ROLES";
    private currentSystem: string = this.config.get('currentsystem');
    private loginUrl = `${this.config.get('apiUrl')}AccessControl/Login`;

    userLogIn: Promise<boolean>;

    constructor(private config: AppConfig, private http: Http) {}

    login(name?: string, password?: string) {
        if (!this.userLogIn) {
            this.userLogIn = new Promise((resolve, reject) => {
                this.http.post(this.loginUrl, null, null)
                    .map((response: Response) => <User>response.json())
                    .subscribe((data: User) => {
                        sessionStorage.setItem( "userAuth", "true");
                        sessionStorage.setItem( "userRoles", data.Roles.join(',') );
                        sessionStorage.setItem( "userMenu", JSON.stringify( data.MenuItems ) );
                        sessionStorage.setItem( "userData", JSON.stringify( data ) );
                        sessionStorage.setItem( "isGlobalUser", JSON.stringify( data.isGlobalUser ) );
                        
                        if (this.currentSystem != "")
                            sessionStorage.setItem("emulateResetUserData", JSON.stringify(data));

                        resolve(true);
                    },
                    err => {
                        resolve(false);
                    })
            });
        }
        return this.userLogIn;
    }

    logOut() {
        sessionStorage.clear();
    }

    get userRoles(): Array<string> {
        const userRoles = localStorage.getItem(this._userRolesKey);
        return userRoles.split(',');
    }

    get currentUser(): string {
        return localStorage.getItem(this._userKey);
    }

    set currentUser(user: string) {
        localStorage.setItem(this._userKey, user);
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/authentication/authentication.ts